//For AWS
export default {
    Region: 'ap-northeast-1',
    UserPoolId: 'ap-northeast-1_aGJxp3CGL',
    ClientId: '408a48oig9pdau3r9k6trkak09',
    IdentityPoolId: 'ap-northeast-1:0511bbf3-ffb5-4bf5-a2bc-e58bf097156c'
  }